import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Loader2, Sparkles } from "lucide-react";
import InterventionActionPlan from "@/components/InterventionActionPlan";

export { splitIntoInsightBuckets } from "@/utils/splitIntoInsightBuckets";

export const CollapsibleInsights = ({ content, defaultRoot = [], defaultRecs = [], defaultActions = [] }) => (
  <InterventionActionPlan
    aiContent={content || ""}
    defaultRoot={defaultRoot}
    defaultRecs={defaultRecs}
    defaultActions={defaultActions}
    showCreateTasks={false}
  />
);

export default function AiInsightsCard({ title = "AI Insights", content, loading, provider }) {
  if (loading) {
    return (
      <Card className="border-slate-200 bg-gradient-to-br from-purple-50 to-blue-50">
        <CardContent className="p-6 flex items-center justify-center h-56">
          <div className="flex flex-col items-center gap-3">
            <Loader2 className="w-8 h-8 animate-spin text-purple-600" />
            <p className="text-slate-500">Generating insights…</p>
          </div>
        </CardContent>
      </Card>
    );
  }

  return (
    <Card className="border-slate-200 bg-gradient-to-br from-purple-50 to-blue-50">
      <CardHeader className="pb-2">
        <CardTitle className="text-lg flex items-center gap-2 flex-wrap">
          <Sparkles className="w-5 h-5 text-purple-600" />
          {title}
          {provider ? (
            <span
              className={`text-xs font-medium px-2 py-0.5 rounded-full ${
                provider === "mistral"
                  ? "bg-purple-100 text-purple-700"
                  : "bg-slate-100 text-slate-600"
              }`}
            >
              {provider === "mistral" ? "Mistral AI" : "Rule-based"}
            </span>
          ) : null}
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="max-h-96 overflow-y-auto pr-2">
          <CollapsibleInsights content={content || ""} />
        </div>
      </CardContent>
    </Card>
  );
}


